// Lich su cac lan chay. Bam mot dong de xem lai toan bo nhat ky cua lan do.

import { useEffect, useState } from "react";
import { api } from "../api";
import Console from "../components/Console";
import { Empty, ErrorBox, Spinner, StatusBadge } from "../components/ui";
import { useRunStream } from "../hooks/useRunStream";
import type { RunMeta } from "../types";

export default function RunsPage() {
  const [runs, setRuns] = useState<RunMeta[] | null>(null);
  const [chon, setChon] = useState<string | null>(null);
  const [loi, setLoi] = useState<unknown>(null);
  const { run, log, noi, dangChay } = useRunStream(chon);

  const nap = () => {
    api
      .runs(100)
      .then((r) => {
        setRuns(r.runs);
        setChon((cu) => cu ?? r.dang_chay?.id ?? r.runs[0]?.id ?? null);
      })
      .catch(setLoi);
  };

  useEffect(nap, []);

  // Lan chay hien tai ket thuc -> so lieu trong bang da cu.
  useEffect(() => {
    if (run && !dangChay) nap();
  }, [run?.status]);

  if (loi && !runs) return <div className="content-pad"><ErrorBox error={loi} /></div>;
  if (!runs) return <div className="content-pad"><Spinner /></div>;

  return (
    <div className="content-pad" style={{ maxWidth: 1400 }}>
      <div className="card">
        <div className="card-head">
          <h2 className="grow">Lịch sử chạy</h2>
          <button className="btn btn-sm" onClick={nap}>↻ Nạp lại</button>
        </div>
        {runs.length === 0 ? (
          <Empty>Chưa có lần chạy nào.</Empty>
        ) : (
          <div className="bang-cuon" style={{ maxHeight: 320, overflowY: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>Bước</th>
                  <th>Bắt đầu</th>
                  <th>Kết thúc</th>
                  <th>Trạng thái</th>
                  <th>Dòng log</th>
                </tr>
              </thead>
              <tbody>
                {runs.map((r) => (
                  <tr
                    key={r.id}
                    className="clickable"
                    onClick={() => setChon(r.id)}
                    style={chon === r.id ? { background: "var(--accent-soft)" } : undefined}
                  >
                    <td>
                      <div style={{ fontWeight: 550 }}>{r.step_label}</div>
                      <div className="mono muted small">{r.id}</div>
                    </td>
                    <td className="small">{r.started_at}</td>
                    <td className="small">{r.ended_at ?? "—"}</td>
                    <td><StatusBadge status={r.status} /></td>
                    <td className="small">{r.so_dong}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {chon ? (
        <div style={{ marginTop: 16, height: 460, display: "flex" }}>
          <Console
            log={log}
            run={run}
            dangChay={dangChay}
            trangThaiNoi={noi}
            onCancel={() => chon && api.cancelRun(chon).catch(setLoi)}
          />
        </div>
      ) : null}
    </div>
  );
}
